import { createSelector } from 'reselect';

const selectShopState = (state) => state.shopReducer;

export const getShopToken = () => createSelector(
  selectShopState,
  ({ shopToken, error, loading }) => ({ shopToken, error })
);
